<template>
  <div class="map-container">
    <div id="AMap" ref="AMap" v-loading="loading" element-loading-text="加载中, 请稍后..."
         element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"></div>
  </div>
</template>

<script>
import AMap from "AMap";
import extHigh from "../assets/map/extHigh.webp";
import high from "../assets/map/high.webp";
import medium from "../assets/map/medium.webp";
import low from "../assets/map/low.webp";
import extLow from "../assets/map/extLow.webp";
import star from "../assets/map/star.png";
import redStar from "../assets/map/redStar.jpg";
import {getEventLevel, getThreatLevel} from "../utils";


export default {
  name: "AMap",
  props: {
    center: {
      type: Array,
      default: () => [104.114129, 36.550339]
    },
    zoom: {
      type: Number,
      default: 5
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      map: null,
      polygons: [],
      text: [],
      marker: [],
      imageList: {
        extHigh: extHigh,
        high: high,
        medium: medium,
        low: low,
        extLow: extLow,
        star: star,
        redStar: redStar
      },
      star: star,
      redStar: redStar
    };
  },
  mounted() {
    this.init();
    this.map.on("rightclick", () => {
      this.$parent.params.area_code = "";
      this.$parent.params.region = "";
      // 在这里调用返回到中国地图的方法
      this.$parent.getAssetGeoList();
      this.$parent.vulInfoClose();
      this.$parent.active = "";
      this.$parent.$refs.map.resetZoom();
    });
  },
  methods: {
    init() {
      this.map = new AMap.Map("AMap", {
        center: this.center,
        zoom: this.zoom,
        roam: true,
        // mapStyle: "amap://styles/e9b39704a57f7637e4561683b5ccd403" // 俊强
        mapStyle: "amap://styles/48321e0e93fae7c0ce1747aee35fc53f"
      });
      this.map.on("complete", () => {
        this.$emit("complete");
      });
    },
    zoomIn() {
      this.map.zoomIn();
    },
    zoomOut() {
      this.map.zoomOut();
    },
    resetZoom() {
      this.map.setZoom(this.zoom);
      this.map.setCenter(this.center);
    },
    setCenterAndZoom(center, zoom) {
      this.map.setZoom(zoom);
      this.map.setCenter(center);
    },
    clearMap() {
      this.map.clearMap();
    },
    setMarker(data, type) {
      this.$emit("update:loading", true);
      this.marker = [];
      data.forEach(item => {
        let score = type === "safe" ? getEventLevel(item.threatLevel) : getThreatLevel(item.threatScore);

        let marker = new AMap.Marker({
          position: new AMap.LngLat(item.position[0], item.position[1]),
          offset: new AMap.Pixel(-35, -35),
          icon: new AMap.Icon({
            size: new AMap.Size(70, 70),
            imageOffset: new AMap.Pixel(0, 0),
            image: this.imageList[score.clazz],
            imageSize: new AMap.Size(70, 70)
          }),
          zIndex: score.level
        });

        marker.on("click", (event) => {
          this.$emit("markerClick", item, event);
        });
        this.marker.push(marker);
      });
      this.map.add(this.marker);
      this.$nextTick(() => {
        this.$emit("update:loading", false);
      });
    },
    setIotMarker(data, type) {
      this.$emit("update:loading", true);
      this.marker = [];
      data.forEach(item => {
        let score = type === "safe" ? getEventLevel(item.threatLevel) : getThreatLevel(item.threatScore);

        let marker = new AMap.Marker({
          position: new AMap.LngLat(item.position[0], item.position[1]),
          offset: new AMap.Pixel(-10, -10),
          icon: new AMap.Icon({
            size: new AMap.Size(20, 20),
            imageOffset: new AMap.Pixel(0, 0),
            image: score.clazz === "extHigh" || score.clazz === "high" ? this.redStar : this.star,
            imageSize: new AMap.Size(20, 20)
          }),
          zIndex: score.level
        });

        marker.on("click", (event) => {
          this.$emit("markerClick", item, event);
        });
        this.marker.push(marker);
      });
      this.map.add(this.marker);
      this.$nextTick(() => {
        this.$emit("update:loading", false);
      });
    },
    setPolygon(data, type) {
      this.$emit("update:loading", true);
      let opts = {
        subdistrict: 2,
        extensions: "all",
        level: "district"
      };

      this.polygons = [];
      this.text = [];

      let district = new AMap.DistrictSearch(opts);

      let all = [];

      // 行政区查询
      data.forEach(item => {
        let color = type === "safe" ? getEventLevel(item.threatLevel).color : getThreatLevel(item.threatScore).color;

        all.push(new Promise((resolve) => {
          district.search(item.code, (status, result) => {
            if (status === "complete") {
              let bounds = result.districtList[0].boundaries;

              let center = [result.districtList[0].center.lng, result.districtList[0].center.lat];

              if (bounds) {
                bounds.forEach(i => {
                  let polygon = new AMap.Polygon({
                    strokeWeight: 2,
                    path: i,
                    fillOpacity: 0.5,
                    fillColor: color,
                    strokeColor: color
                  });

                  polygon.on("click", () => {
                    if (result.districtList[0].level === "province") {
                      // 如果是省份级别，查询该省内各个市的信息
                      this.$emit("areaClick", item);
                      this.$parent.getGeoRegion("province");
                      this.setCity(item); // 这里调用一个方法来展示市级别的地图信息
                    } else if (result.districtList[0].level === "city") {
                      // 如果是市级别，查询该市内各个区县的信息
                      this.$emit("areaClick", item);
                      this.$parent.getGeoRegion("city");
                      this.setDistrict(item.name); // 这里调用一个方法来展示区县级别的地图信息
                    } else {
                    }
                  });

                  this.polygons.push(polygon);
                });
              }
              let text = new AMap.Text({
                text: `${item.name}: ${item.sumVul}`,
                offset: new AMap.Pixel(-5, -5),
                style: {
                  "background": "none",
                  "border-width": 0,
                  "text-align": "left",
                  "font-size": "12px",
                  "color": "#ff0"
                },
                position: center
              });

              // text.on("click", () => {
              //   this.$emit("areaClick", item);
              //   if (result.districtList[0].level === "province") {
              //     this.$parent.getGeoRegion("province");
              //     this.setCity(item); // 点击省份时展示市级别地图信息
              //   } else if (result.districtList[0].level === "city") {
              //     this.$parent.getGeoRegion("city");
              //     this.setDistrict(item.name); // 点击市时展示区县级别地图信息
              //   }
              // });

              this.text.push(text);
            }
            resolve();
          });
        }));
      });

      Promise.all(all).then(() => {
        this.map.add(this.polygons);
        this.map.add(this.text);
      }).finally(() => {
        this.$nextTick(() => {
          this.$emit("update:loading", false);
        });
      });
    },

    // 方法用于展示市级别地图信息
    setCity(cityItem) {
      this.$emit("update:loading", true);
      // 清除之前的地图信息
      this.map.clearMap();
      this.polygons = [];
      this.text = [];

      let district = new AMap.DistrictSearch({
        subdistrict: 1, // 获取市级别的数据
        extensions: "all",
        level: "city"
      });

      district.search(cityItem.code, (status, result) => {
        if (status === "complete" && result.districtList) {
          let cities = result.districtList[0].districtList;

          cities.forEach(city => {
            let cityName = city.name; // 获取市级别的名称

            let cityCode = city.adcode;

            // 根据市的名称进行单独的查询，获取市级别的边界数据
            let cityDistrict = new AMap.DistrictSearch({
              subdistrict: 2,
              extensions: "all",
              level: "district"
            });

            cityDistrict.search(cityName, (cityStatus, cityResult) => {
              if (cityStatus === "complete" && cityResult.districtList) {
                let bounds = cityResult.districtList[0].boundaries;

                if (bounds) {
                  bounds.forEach(i => {
                    let polygon = new AMap.Polygon({
                      strokeWeight: 1,
                      path: i,
                      fillOpacity: 0,
                      fillColor: "#e1f36a",
                      strokeColor: "#06fa2a"
                    });

                    polygon.on("click", () => {
                      let cityItem = {code: cityCode, name: cityName};

                      this.$emit("areaClick", cityItem);
                      if (cityResult.districtList[0].level === "city") {
                        this.$parent.getGeoRegion("city");
                        this.setDistrict(cityName);
                      }
                    });

                    this.polygons.push(polygon);
                  });
                }
                this.map.add(this.polygons);
                this.map.setFitView(this.polygons); // 调整地图视图以适应市级地图
                this.$emit("update:loading", false);
              }
            });
          });
        }
      });
    },


    // 方法用于展示区县级别地图信息
    setDistrict(districtItem) {
      this.$emit("update:loading", true);
      // 清除之前的地图信息
      this.map.clearMap();
      this.polygons = [];

      let district = new AMap.DistrictSearch({
        subdistrict: 1, // 获取区县级别的数据
        extensions: "all",
        level: "district"
      });

      district.search(districtItem, (status, result) => {
        if (status === "complete" && result.districtList) {
          let cities = result.districtList[0].districtList;

          cities.forEach(city => {
            let districtName = city.name; // 获取市级别的名称

            let districtCode = city.adcode; // 获取市级别的code

            // 根据市的名称进行单独的查询，获取市级别的边界数据
            let cityDistrict = new AMap.DistrictSearch({
              subdistrict: 2,
              extensions: "all",
              level: "district"
            });

            cityDistrict.search(districtCode, (cityStatus, cityResult) => {
              if (cityStatus === "complete" && cityResult.districtList) {
                let bounds = cityResult.districtList[0].boundaries;

                if (bounds) {
                  bounds.forEach(i => {
                    let polygon = new AMap.Polygon({
                      strokeWeight: 1,
                      path: i,
                      fillOpacity: 0,
                      fillColor: "#e1f36a",
                      strokeColor: "#06fa2a"
                    });

                    this.polygons.push(polygon);
                  });
                }

                this.map.add(this.polygons);
                this.map.setFitView(this.polygons); // 调整地图视图以适应市级地图
                this.$emit("update:loading", false);
              }
            });
          });
        }
      });
    }


  }
};
</script>

<style lang="less" scoped>
.map-container {
  position: absolute;
  z-index: 0;
  top: 0;
  width: 100%;
  height: 100%;

  .amap-container {
    width: 100%;
    height: 100%;
  }
}

/deep/ .amap-logo {
  display: none !important;
}
</style>
